import Button from "atoms/buttons/button";
import { ButtonSizes } from "atoms/constants/button-sizes";
import { ButtonStyles } from "atoms/constants/button-styles";
import { HeadingPriority } from "atoms/constants/heading-priority";
import { IconSizes } from "atoms/constants/icon-sizes";
import { Icons } from "atoms/constants/icons";
import Icon from "atoms/icons/icon";
import Heading from "atoms/typography/heading";
import CollapsePanel from "molecules/collapse-panel/collapse-panel";
import React from "react";
import { useHistory } from "react-router";
import { useGlobalState } from "utilities/contexts/use-global-state-context";
import { t } from "utilities/localization-utils";

interface CitationItemDisplayProps {
    bookviewRoute: string | undefined;
    citationDisplayTitle: string | undefined;
    publicationTitle: string | undefined;
    body: React.ReactNode;
    collapse?: boolean;
}

const CSS_BASE_CLASS = "c-share-space-item-display";

const CitationItemDisplay: React.FC<CitationItemDisplayProps> = ({
    bookviewRoute,
    citationDisplayTitle,
    publicationTitle,
    body,
    collapse = true,
}) => {
    const { push } = useHistory();
    const { isAuthenticated } = useGlobalState();

    const handleOnBookviewClick = () => {
        push(bookviewRoute!);
    };
    const PanelTop = () => {
        return (
            <header className={`${CSS_BASE_CLASS}__header`}>
                <div className={`${CSS_BASE_CLASS}__headerText`}>
                    <Heading
                        priority={HeadingPriority.Four}
                        cssClassName={`${CSS_BASE_CLASS}__title`}>
                        {citationDisplayTitle}
                    </Heading>
                    <Heading
                        priority={HeadingPriority.Five}
                        cssClassName={`${CSS_BASE_CLASS}__publication`}>
                        {publicationTitle}
                    </Heading>
                </div>
                {isAuthenticated && bookviewRoute && (
                    <Button
                        size={ButtonSizes.Small}
                        onClick={handleOnBookviewClick}
                        cssClassName={`${CSS_BASE_CLASS}__bookviewButton`}
                        style={ButtonStyles.Secondary}>
                        <Icon type={Icons.OpenBook} />
                        {t("openInBookView")}
                    </Button>
                )}
            </header>
        );
    };

    return (
        <CollapsePanel
            iconSize={IconSizes.Base}
            modifierCSSClassName={CSS_BASE_CLASS}
            buttonAriaText={""}
            collapse={collapse}
            useToggleOnRight
            panelTop={<PanelTop />}>
            <section className={`${CSS_BASE_CLASS}__body`}>{body}</section>
        </CollapsePanel>
    );
};

export default CitationItemDisplay;
